module.exports = __webpack_public_path__ + "img/gongzi.19025f05.png";